@if (loading) {
    <div class="loading"></div>
}
@if (!loading) {
    <form class="form-horizontal">
        <div class="form-group">
            <label for="username" class="col-md-2 control-label"> Username </label>
            <div class="col-md-4 list-div">
                <div>{{ user.Username }}</div>
            </div>
        </div>
        <div class="form-group">
            <label for="email" class="col-md-2 control-label"> Email </label>
            <div class="col-md-4 list-div">
                <div>{{ user.Email }}</div>
            </div>
        </div>
        <hr />
        <div class="form-group">
            <label for="username" class="col-md-2 control-label" style="justify-self: left"> Groups </label>
            <div class="col-md-4 list-div">
                <div>
                    @for (group of user.Groups; track group) {
                        <div>{{ group }}</div>
                    }
                </div>
            </div>
        </div>
        <hr />
        <div class="form-group">
            <label for="roles" class="col-md-2 control-label" style="justify-self: left"> Roles </label>
            <div class="col-md-4 list-div">
                @if (user.Admin) {
                    <div>Admin</div>
                }
                @if (user.ScanAdmin) {
                    <div>Scan Admin</div>
                }
                @if (user.ARReports) {
                    <div>AR Report User</div>
                }
                @if (user.FINReports) {
                    <div>FIN Report User</div>
                }
                @if (user.APCheckAdmin) {
                    <div>AP-Check Admin</div>
                }
                @if (user.APCheckUser) {
                    <div>AP-Check User</div>
                }
                @if (user.PTPAdmin) {
                    <div>Purchase To Pay - Global Admin</div>
                }
                @if (user.PTPLocationAdmin) {
                    <div>Purchase To Pay - Location Admin</div>
                }
            </div>
        </div>
    </form>
}
